// extracted by mini-css-extract-plugin
module.exports = {"container":"partners_container__262TB","companyContainer":"partners_companyContainer__1Lduw"};